const ErrorCode = {
    1001: "没有找到指定的用户.",
    2001: "没有找到指定的订单.",
    2002: "订单状态错误.",
    10001: "没有找到指定的交易对",
    10002: "账户余额不足，请检查当前账户或划转。",

    msg: (code) => {
        if (ErrorCode[code] == null) {
            return "错误，请稍候重试...";
        }
        return ErrorCode[code];
    }
}

export default ErrorCode;